// フォームの HTML。
//
// 入口は「ご注文方法のご案内」の3択カード（Issue #20。ES さんが page/2524 に作った HTML/CSS）。
// フォームは**常にカードの下に出ている**（Issue #24）。カード②③は種別の選択に使う —
// 押すとフォーム内のラジオがその種別になり、カードが強調される。カード①はフォーム不要
// （そのまま買ってもらう）なので押せない。
// 「分納での発送は承っておりません」は③に関係ないので、②カードの中（説明文の下）に置く（Issue #24 の 6）。
// 元 HTML の `data-kind` は page/2524 の旧フォームのラジオ id（zk_kind2/3）を指していたが、
// ここでは種別の値（1=予約注文 / 2=入荷通知）に付け替えてある。
// ★page/2524 の下半分（.zkform・ES さんの Worker へ POST する旧フォーム）は取り込まない。
//
// ★旧リード文（【ご希望の数量が在庫を上回っています】…3つの場合分け）は出さない
//   （田口さん 2026-09-03。カードと説明が二重になるため）。文言は text.ts の lead に残してある。
//   在庫数の一行（PR #14 の .js-stock）は置き場ごと無くしていたが、2026-09-10 の田口さん指示で
//   カード①の中に「現在の在庫数」と「▶ 購入ページへ」（②③の合図と同じ体裁）を置く形にした。在庫が引けたときだけ出す
//   （index.ts が .js-stock / .js-back の hidden を外す）。戻り先は /product/{管理番号}。
//
// フォーム本体の項目の並びと見出しは page/2510 を踏襲。差分は次の3つ:
//   ・選択肢が「不足分のみ購入 / 一括で納品」→「予約する / 入荷したら知らせてほしい」
//   ・商品名は入力させず、ウィジェットの属性で受け取った値を表示して送る
//   ・希望納期の欄は無い（列が無い。入荷時期はこちらから伝える運用）
//
// ★固定 id を持たない（Issue #19）。同じページに2つ載ると label の for が1つ目に紐づく。
//   order-status と同じく class で引き、label は入力欄を包む形にして for を使わない。

import { TEXT as T } from './text'

const esc = (s: string): string =>
  s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!)

/** 見出し横の飾り線（左右で向きが違う） */
const DECO_L = `<svg class="deco" viewBox="0 0 40 40" aria-hidden="true"><g fill="none" stroke="#6cb33f" stroke-width="4" stroke-linecap="round"><path d="M8 8l10 13"/><path d="M24 6l7 15"/></g></svg>`
const DECO_R = `<svg class="deco" viewBox="0 0 40 40" aria-hidden="true"><g fill="none" stroke="#6cb33f" stroke-width="4" stroke-linecap="round"><path d="M32 8L22 21"/><path d="M16 6L9 21"/></g></svg>`

/** 見出しの下線 */
const ULINE = `<svg class="zkg-uline" viewBox="0 0 800 16" aria-hidden="true"><path d="M3 3H385l15 10 15-10h382" fill="none" stroke="#7ab648" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`

/** カード①の絵（段ボールとカート） */
const FIG_STOCK = `<svg viewBox="0 0 168 140" width="168" height="140" role="img" aria-label="${T.cards.stock.figLabel}">
  <rect x="14" y="40" width="100" height="74" rx="3" fill="#e7bd8a" stroke="#c08b52" stroke-width="3"/>
  <rect x="14" y="26" width="100" height="18" rx="3" fill="#f3d5a8" stroke="#c08b52" stroke-width="3"/>
  <rect x="54" y="26" width="20" height="88" fill="#d9a970" stroke="#c08b52" stroke-width="2.5"/>
  <circle cx="126" cy="92" r="30" fill="#fff" stroke="#3f9a3a" stroke-width="4"/>
  <g stroke="#3f9a3a" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d="M110 80h5l3.5 9"/>
    <path d="M119.5 90h23l-4 12h-15z" fill="#3f9a3a" stroke="none"/>
    <path d="M119.5 90h23l-4 12h-15z"/>
  </g>
  <circle cx="124" cy="107" r="3" fill="#3f9a3a"/>
  <circle cx="137" cy="107" r="3" fill="#3f9a3a"/>
</svg>`

/** カード②の絵（段ボール3つと予約注文のスマホ） */
const FIG_RESERVE = `<svg viewBox="0 0 196 140" width="196" height="140" role="img" aria-label="${T.cards.reserve.figLabel}">
  <rect x="26" y="32" width="58" height="44" rx="2" fill="#e7bd8a" stroke="#c08b52" stroke-width="3"/>
  <rect x="47" y="32" width="16" height="44" fill="#d9a970" stroke="#c08b52" stroke-width="2.5"/>
  <rect x="6" y="76" width="58" height="44" rx="2" fill="#e7bd8a" stroke="#c08b52" stroke-width="3"/>
  <rect x="27" y="76" width="16" height="44" fill="#d9a970" stroke="#c08b52" stroke-width="2.5"/>
  <rect x="64" y="76" width="58" height="44" rx="2" fill="#e7bd8a" stroke="#c08b52" stroke-width="3"/>
  <rect x="85" y="76" width="16" height="44" fill="#d9a970" stroke="#c08b52" stroke-width="2.5"/>
  <rect x="112" y="26" width="78" height="102" rx="9" fill="#4c5866"/>
  <rect x="120" y="42" width="62" height="78" rx="4" fill="#fff"/>
  <rect x="138" y="18" width="26" height="16" rx="5" fill="#66727f"/>
  <rect x="120" y="42" width="62" height="20" rx="3" fill="#2f6fd0"/>
  <text x="151" y="57" text-anchor="middle" font-size="13" font-weight="bold" fill="#fff" font-family="sans-serif">${T.cards.reserve.figText}</text>
  <g fill="none" stroke="#2f6fd0" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round">
    <path d="M126 74l4 4 7-8"/><path d="M126 90l4 4 7-8"/><path d="M126 106l4 4 7-8"/>
  </g>
  <g fill="#c9d2da">
    <rect x="142" y="72" width="34" height="4" rx="2"/>
    <rect x="142" y="88" width="34" height="4" rx="2"/>
    <rect x="142" y="104" width="34" height="4" rx="2"/>
  </g>
</svg>`

/** カード③の絵（ベルとメール） */
const FIG_NOTIFY = `<svg viewBox="-8 -4 186 138" width="186" height="138" role="img" aria-label="${T.cards.notify.figLabel}">
  <g fill="none" stroke="#f5c33c" stroke-width="4" stroke-linecap="round">
    <path d="M18 44c-6 8-6 22 0 30"/><path d="M6 36c-9 13-9 33 0 46"/>
  </g>
  <path d="M62 26c-14 0-25 11-25 25v20l-8 10h66l-8-10V51c0-14-11-25-25-25z" fill="#f8ca41" stroke="#e0a92a" stroke-width="3" stroke-linejoin="round"/>
  <circle cx="62" cy="22" r="6" fill="#f8ca41" stroke="#e0a92a" stroke-width="3"/>
  <path d="M52 91a10 10 0 0 0 20 0z" fill="#f8ca41" stroke="#e0a92a" stroke-width="3" stroke-linejoin="round"/>
  <rect x="98" y="44" width="72" height="54" rx="5" fill="#fbdce4" stroke="#ef9fb4" stroke-width="3"/>
  <path d="M100 47l34 27 34-27" fill="none" stroke="#ef9fb4" stroke-width="3" stroke-linejoin="round"/>
</svg>`

/** 注意書きの三角アイコン */
const FIG_WARN = `<svg viewBox="0 0 40 36" role="img" aria-label="${T.cards.warnLabel}">
  <path d="M20 3l18 30H2z" fill="#ffd34d" stroke="#e8b62c" stroke-width="2" stroke-linejoin="round"/>
  <path d="M20 13v9" stroke="#5a4a10" stroke-width="3.2" stroke-linecap="round"/>
  <circle cx="20" cy="27.5" r="2.2" fill="#5a4a10"/>
</svg>`

/**
 * 入口の3択カード。②③だけが押せる（js-pick + data-kind=種別の値）。①は在庫数と商品ページへの戻り。
 * soldOut（在庫切れの商品ページから ?soldout=1 で来たとき）は①が成り立たないので出さず、②③の2択にする
 * （2026-09-11 田口さん指示）
 */
function cards(productCode: number, soldOut: boolean): string {
  const C = T.cards
  const card1 = soldOut
    ? ''
    : `
    <section class="zkg-card zkg-c1">
      <div class="zkg-hd">${C.stock.head}</div>
      <hr class="zkg-sep">
      <div class="zkg-fig">${FIG_STOCK}</div>
      <p class="zkg-desc">${C.stock.desc}</p>
      <p class="zkg-stock js-stock" hidden></p>
      <p class="zkg-cta js-back" hidden><a class="zkg-back" href="/product/${productCode}">${C.stock.back}</a></p>
    </section>
`
  return `
<div class="zkg js-cards">
  <div class="zkg-head">${DECO_L}<h2 class="zkg-h">${C.title}</h2>${DECO_R}</div>
  ${ULINE}

  <div class="zkg-cards${soldOut ? ' zkg-two' : ''}">${card1}

    <section class="zkg-card zkg-c2 zkg-pick js-pick" data-kind="1" role="button" tabindex="0" aria-pressed="false" aria-label="${C.reserve.pickLabel}">
      <div class="zkg-hd">${C.reserve.head}</div>
      <hr class="zkg-sep">
      <div class="zkg-fig">${FIG_RESERVE}</div>
      <p class="zkg-desc">${C.reserve.desc}</p>
      <p class="zkg-pill">${C.pill}</p>
      <p class="zkg-cta">${C.pickHint}</p>
    </section>

    <section class="zkg-card zkg-c3 zkg-pick js-pick" data-kind="2" role="button" tabindex="0" aria-pressed="false" aria-label="${C.notify.pickLabel}">
      <div class="zkg-hd">${C.notify.head}</div>
      <hr class="zkg-sep">
      <div class="zkg-fig">${FIG_NOTIFY}</div>
      <p class="zkg-desc">${C.notify.desc}</p>
      <p class="zkg-cta">${C.pickHint}</p>
    </section>
  </div>

  <div class="zkg-warn">${FIG_WARN}<p>${C.warn}</p></div>
</div>
`
}

export function html(productName: string, productCode: number, opts: { soldOut?: boolean } = {}): string {
  const req = `<span class="req">${T.label.required}</span>`
  return `
${cards(productCode, opts.soldOut === true)}

<div class="zk-panel js-panel">
  <form class="js-form" novalidate>
    <h3>${T.section.wish}</h3>

    <div class="fld">
      <span class="q">${T.label.kind}${req}</span>
      <label class="radio"><input type="radio" name="kind" value="1"> ${T.label.kindReserve}<small>（${T.label.kindReserveNote}）</small></label>
      <label class="radio"><input type="radio" name="kind" value="2"> ${T.label.kindNotify}<small>（${T.label.kindNotifyNote}）</small></label>
    </div>

    <div class="fld">
      <span class="q">${T.label.product}</span>
      <div class="prod js-prod">${esc(productName)}</div>
    </div>

    <label class="fld">
      <span class="q js-qtylabel">${T.label.quantity}${req}</span>
      <input type="text" name="quantity" inputmode="numeric" placeholder="${T.placeholder.quantity}">
    </label>

    <label class="fld">
      <span class="q">${T.label.note}</span>
      <textarea name="note" placeholder="${T.placeholder.note}"></textarea>
    </label>

    <h3>${T.section.customer}</h3>

    <label class="fld">
      <span class="q">${T.label.name}${req}</span>
      <input type="text" name="name" autocomplete="name">
    </label>
    <label class="fld">
      <span class="q">${T.label.company}</span>
      <input type="text" name="company" autocomplete="organization">
    </label>
    <label class="fld">
      <span class="q">${T.label.email}${req}</span>
      <input type="email" name="email" autocomplete="email" placeholder="${T.placeholder.email}">
    </label>
    <label class="fld">
      <span class="q">${T.label.tel}</span>
      <input type="tel" name="tel" autocomplete="tel" placeholder="${T.placeholder.tel}">
    </label>

    <!-- ハニーポット（人には見えない。botが埋めると送信を破棄する） -->
    <div class="hp"><label>ウェブサイト<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>

    <div class="msg js-inline"></div>
    <p style="text-align:center;"><button type="submit" class="btn js-submit" disabled>${T.submit}</button></p>
    <p class="note">${T.note}</p>
  </form>

  <!-- 完了メッセージはフォームの外。フォームを隠しても消えないように。 -->
  <div class="msg js-done"></div>
</div>
`
}

/**
 * 送信完了の枠（.js-done の中身）。フォームを隠した場所に「送信完了」を大きく出し、受け付けた内容を手元の入力値だけで要約する
 * （DB は読み返せない。CLAUDE.md「登録完了画面は手元の入力値で組み立てる」）。★「数分以内」など届く時期は書かない
 */
export function doneHtml(v: { kindLabel: string; productName: string; quantity: number | null }): string {
  const qty = v.quantity === null ? T.doneQuantityNone : esc(v.quantity.toLocaleString('ja-JP'))
  return `
<div class="zk-done-head"><span class="zk-done-check" aria-hidden="true">✓</span><strong>${T.doneTitle}</strong></div>
<p class="zk-done-text">${T.done}</p>
<dl class="zk-done-sum">
  <dt>${T.label.kind}</dt><dd>${esc(v.kindLabel)}</dd>
  <dt>${T.label.product}</dt><dd>${esc(v.productName)}</dd>
  <dt>${T.label.quantityOptional}</dt><dd>${qty}</dd>
</dl>
<span class="zk-mail">${T.doneMail}</span>
`
}
